export const BID_DATE_TYPE = Object.freeze({
  BID_EFFECTIVE_DATE: "Bid Effective Date",
  BID_WINDOW_DATE: "Bid Window Date",
  LAST_UPDATED_DATE: "Last Updated",
});

export const EMPLOYEE_BID_DATE_TYPE = Object.freeze({
  BID_EFFECTIVE_DATE: "Bid Effective Date",
  BID_WINDOW_DATE: "Bid Window Date",
});

export const TWU_DECLARATIONS = Object.freeze({
  FTO: "FTO",
  FREEDAY: "Freeday",
});

export const BID_TYPE = Object.freeze({
  SHIFT: "Shift Bid",
  FREEDAY: "TWU Freeday Bid",
  FTO: "IAM FTO Bid",
  TWU_DAT_FTO: "TWU DAT/FTO Bid",
  IAM_DAT: "IAM DAT Bid",
  NC_PTO_FTO: "Non-Contract PTO/FTO Bid",
  NC_PTO_GOC_HOL: "Non-Contract PTO/GOC-HOL Bid",
});

export const BID_AWARDED_TIME_OFF_TYPES = Object.freeze({
  FREEDAY: "Freeday",
  FTO: "FTO",
  TWU_DAT_FTO: "DAT/FTO",
  DAT: "DAT",
  PTO_FTO: "PTO/FTO",
  PTO_GOC_HOL: "PTO/GOC-HOL",
});

export const TWU_DAT_FTO_BID_TIME_OFF_TYPES = Object.freeze({
  FTO: "FTO",
  DAT: "DAT",
});

export const NC_PTO_FTO_BID_TIME_OFF_TYPES = Object.freeze({
  PTO: "PTO",
  FTO: "FTO",
});

export const NC_PTO_GOC_HOL_BID_TIME_OFF_TYPES = Object.freeze({
  PTO: "PTO",
  GOC_HOL: "GOC-HOL", // Need to update this?
});

export const BID_STATUS = Object.freeze({
  AWARDED: "Awarded",
  CLOSED: "Closed",
  DELETED: "Deleted",
  OPEN: "Open",
  PENDING: "Pending",
  WITHDRAWN: "Withdrawn",
});

export const EMPLOYEE_BID_STATUS = Object.freeze({
  AWARDED: "Awarded",
  CLOSED: "Closed",
  OPEN: "Open",
  WITHDRAWN: "Withdrawn",
});

export const BID_SCHEDULED_STATUS = Object.freeze({
  NOT_SCHEDULED: "Not Scheduled",
  SCHEDULED: "Scheduled",
  DELAYED: "Delayed",
});

export const BID_ACTIONS = Object.freeze({
  DELETE: "Delete",
  WITHDRAW: "Withdraw",
  AWARD: "Award",
  RESULTS: "Results",
});

export const BID_EVENT_TYPE = Object.freeze({
  CREATE: "CREATE",
  EDIT: "EDIT",
  DELETE: "DELETE",
});

export const ALL_BID_POSITION_FILTERS = Object.freeze({
  FREIGHT: "Freight",
  GATES: "Gates",
});

export const ALL_BID_DAYS_OFF_FILTERS = Object.freeze({
  SAT_SUN: "Sat/Sun",
  SUN_MON: "Sun/Mon",
  MON_TUE: "Mon/Tue",
  TUE_WED: "Tue/Wed",
  WED_THU: "Wed/Thu",
  THU_FRI: "Thu/Fri",
  FRI_SAT: "Fri/Sat",
});

export const ALL_BID_START_TIMES_FILTERS = Object.freeze({
  "0400": "04:00",
  "0500": "05:00",
  "0600": "06:00",
  "0700": "07:00",
  "0800": "08:00",
});

export const BID_FORM_START_TIME_VALUES = Object.freeze({
  "0001": "00:01-00:30",
  "0031": "00:31-01:00",
  "0101": "01:01-01:30",
  "0131": "01:31-02:00",
  "0201": "02:01-02:30",
  "0231": "02:31-03:00",
  "0301": "03:01-03:30",
  "0331": "03:31-04:00",
  "0401": "04:01-04:30",
  "0431": "04:31-05:00",
  "0501": "05:01-05:30",
  "0531": "05:31-06:00",
  "0601": "06:01-06:30",
  "0631": "06:31-07:00",
  "0701": "07:01-07:30",
  "0731": "07:31-08:00",
  "0801": "08:01-08:30",
  "0831": "08:31-09:00",
  "0901": "09:01-09:30",
  "0931": "09:31-10:00",
  1001: "10:01-10:30",
  1031: "10:31-11:00",
  1101: "11:01-11:30",
  1131: "11:31-12:00",
  1201: "12:01-12:30",
  1231: "12:31-13:00",
  1301: "13:01-13:30",
  1331: "13:31-14:00",
  1401: "14:01-14:30",
  1431: "14:31-15:00",
  1501: "15:01-15:30",
  1531: "15:31-16:00",
  1601: "16:01-16:30",
  1631: "16:31-17:00",
  1701: "17:01-17:30",
  1731: "17:31-18:00",
  1801: "18:01-18:30",
  1831: "18:31-19:00",
  1901: "19:01-19:30",
  1931: "19:31-20:00",
  2001: "20:01-20:30",
  2031: "20:31-21:00",
  2101: "21:01-21:30",
  2131: "21:31-22:00",
  2201: "22:01-22:30",
  2231: "22:31-23:00",
  2301: "23:01-23:30",
  2331: "23:31-00:00",
});

export const PERM_BID_UPDATE_TYPE = Object.freeze({
  CREATE: "CREATE",
});

export const BID_INFO_FILTER_TYPES = Object.freeze({
  ALL_BIDS: "All Bids",
  READY_TO_AWARD: "Ready to Award",
  NOT_SCHEDULED: "Not Scheduled",
  OPEN: "Open",
});

export const BID_SORT_BY_TYPES = Object.freeze({
  BID_EFFECTIVE_DATES: "Bid Effective Dates",
  BID_TYPE: "Bid Type",
  BID_WINDOW_DATES: "Bid Window Dates",
  LAST_UPDATED: "Last Updated",
  STATUS: "Status",
});

export const BID_UPDATE_TYPE = Object.freeze({
  CREATE: "CREATE",
  DELETE: "DELETE",
});

export const BID_AWARDED_FILTER_OPTIONS = Object.freeze({
  ALL: "ALL",
  AWARDED: "Awarded",
  UNAWARDED: "Un-Awarded",
});

export const BID_AWARD_TYPE = Object.freeze({
  AUTO_AWARDED: "AA",
  BLOCK_LINE: "BL",
  PERMANENT_BID: "PB",
  NOT_ENOUGH_CHOICES: "NEC",
  NO_BID: "NB",
  INELIGIBLE_AT_OPEN: "IAO",
  INELIGIBLE_AT_OPEN_AUTO_AWARDED: "IAO-AA",
});

export const ALLOTMENT_TABS = Object.freeze({
  STANDARD: "STANDARD",
  RELIEF: "RELIEF",
});

export const FREEDAY_BID_TYPE = Object.freeze({
  STANDARD: "Standard",
  RELIEF: "Relief",
});

export const FREEDAY_BID_AWARD_TYPE = Object.freeze({
  AUTO_AWARDED: "AA",
  NOT_ENOUGH_CHOICES: "NEC",
  NO_BID: "NB",
  NO_SCHEDULE: "NS",
});

export const IAM_FTO_BID_AWARD_TYPE = Object.freeze({
  AUTO_AWARDED: "AA",
  NOT_ENOUGH_CHOICES: "NEC",
  NO_BID: "NB",
  NO_SCHEDULE: "NS",
  PARTIALLY_AWARDED: "PA",
  ZERO_BALANCE: "ZB",
});

export const TWU_DAT_FTO_BID_AWARD_TYPE = Object.freeze({
  AUTO_AWARDED: "AA",
  NOT_ENOUGH_CHOICES: "NEC",
  NO_BID: "NB",
  NO_SCHEDULE: "NS",
  PARTIALLY_AWARDED: "PA",
  ZERO_BALANCE: "ZB",
});

export const ALLOTMENT_TYPES = Object.freeze({
  AM: "AM",
  AM_EITHER: "AM (Either)",
  PM: "PM",
  PM_EITHER: "PM (Either)",
});

export const BID_GROUP_FILTER_OPTIONS = Object.freeze({
  ALL: "ALL",
  MISSING_BALANCES: "Missing Balances",
});

export const IAM_DAT_BID_AWARD_TYPE = Object.freeze({
  AUTO_AWARDED: "AA",
  NOT_ENOUGH_CHOICES: "NEC",
  NO_BID: "NB",
  NO_SCHEDULE: "NS",
  PARTIALLY_AWARDED: "PA",
  ZERO_BALANCE: "ZB",
});

export const NC_BID_AWARD_TYPE = Object.freeze({
  AUTO_AWARDED: "AA",
  NOT_ENOUGH_CHOICES: "NEC",
  NO_BID: "NB",
  NO_SCHEDULE: "NS",
  PARTIALLY_AWARDED: "PA",
  ZERO_BALANCE: "ZB",
});
